




























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { LoadingService } from '@/services/loadingService';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { Validator } from 'vee-validate';
import { ControlPatentesInterfaces } from '@/pantallas/TorreControl/ControlPatentes/controlPatentesInterfaces';
import { configService } from '@/pantallas/TorreControl/ControlConfiguracion/configService';

@Component({
  name: 'Tiempos',
  components: {
    FormFieldsContainer,
  },
})
export default class Tiempos extends Vue {
  clientId: string;
  isFormValid: boolean = true;
  redTime: string = '';
  yellowTime: string = '';
  progTime: string = '';
  emailsError: string = '';
  loadingService = new LoadingService();
  ConfigService = new configService();
  $snotify: any;
  hint: string = 'Al activar se cambiara la forma de visualizar el dashboard.';

  created() {
    let self = this;
    this.clientId = localStorage.getItem('clienteDefecto');
    this.getData();
  }

  async handleClick() {
    let data = {
      clientId: this.clientId,
      redTime: this.redTime,
      yellowTime: this.yellowTime,
      progTime: this.progTime,
    };
    // const resultadoValidacion = await this.$validator.validateAll();
    const resultadoValidacion = true;
    if (resultadoValidacion) {
      const axiosResponse: AxiosResponse<
        MSResponse<ControlPatentesInterfaces>
      > = await this.ConfigService.saveTimersConfig(data);
      const msResponse: any = axiosResponse.data;
      if (msResponse.CODIGO_RESPUESTA == '1') {
        this.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      } else {
        this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
    }
  }

  async getData() {
    const axiosResponse: AxiosResponse<
      MSResponse<ControlPatentesInterfaces>
    > = await this.ConfigService.getTimerData(this.clientId);
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.redTime = msResponse.redTime;
      this.yellowTime = msResponse.yellowTime;
      this.progTime = msResponse.progTime;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  cleanInput() {
    this.progTime = '';
    this.yellowTime = '';
    this.redTime = '';
  }
}
